import React, { useState } from "react";
import { useGetDocumentsByDaysQuery } from "../../../documents/queries";
import { CustomReportDocumentsTableQuery } from "../../../documents/models";
import { Column } from "react-data-grid";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { Table } from "../../../../components";
import {
  getTableDataByPage,
  getTablePageCount,
  renderServiceObjects,
} from "../../../../helpers/tableHelpers";
import { useNavigate } from "../../../../helpers/navigationHelpers";
import { CPCustomFormReportDocumentDetail } from "../../../../api/models/unified";

const defaultTableQuery: CustomReportDocumentsTableQuery = {
  page: 1,
  pageSize: 10,
};

const HomeCustomReportDocumentsTable: React.FC = (): React.ReactElement => {
  const { tReport } = useCustomTranslation();

  const query = useGetDocumentsByDaysQuery(30);
  const navigate = useNavigate();

  const [queryParams, setQueryParams] =
    useState<CustomReportDocumentsTableQuery>(defaultTableQuery);

  const columns: Column<CPCustomFormReportDocumentDetail>[] = [
    {
      key: "created",
      name: tReport("created"),
      renderCell: ({ row }) => renderDate(row.created),
    },
    {
      key: "orderCode",
      name: tReport("order_code"),
    },
    {
      key: "interventionDay",
      name: tReport("interventionDay"),
      renderCell: ({ row }) => renderDate(row.interventionDay),
    },
    {
      key: "name",
      name: tReport("name"),
      // width: "auto",
    },
    {
      key: "serviceObjectNames",
      name: tReport("serviceObjects"),
      renderCell: ({ row }) => renderServiceObjects(row.serviceObjectNames),
    },
  ];

  return (
    <Table
      columns={columns}
      data={getTableDataByPage(queryParams, query.data?.documents ?? [])}
      loading={query.isLoading}
      queryParams={queryParams}
      onTableQueryChange={setQueryParams}
      pageCount={getTablePageCount(
        query.data?.documents.length ?? 0,
        queryParams.pageSize,
      )}
      onRowClick={(item) => navigate.goTo(`documents/${item.id}`)}
    />
  );
};

export default HomeCustomReportDocumentsTable;
